import React, { forwardRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}
interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  label?: string;
  error?: string;
  hint?: string;
  options: SelectOption[];
  placeholder?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  hint,
  options,
  placeholder,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-634">
        {label && <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1" data-id="element-635">
            {label}
          </label>}
        <div className="relative" data-id="element-636">
          <select ref={ref} className={`
              w-full px-3 py-2 text-sm rounded-md border appearance-none
              bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
              disabled:bg-slate-50 disabled:text-slate-500 dark:disabled:bg-slate-800 dark:disabled:text-slate-500
              ${error ? 'border-red-500 focus:ring-red-500' : 'border-slate-300 dark:border-slate-700'}
              ${className}
            `} {...props} data-id="element-637">
            {placeholder && <option value="" disabled data-id="element-638">
                {placeholder}
              </option>}
            {options.map(option => <option key={option.value} value={option.value} disabled={option.disabled} data-id="element-639">
                {option.label}
              </option>)}
          </select>
          <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 dark:text-slate-500 pointer-events-none" data-id="element-640" />
        </div>
        {hint && !error && <p className="mt-1 text-xs text-slate-500 dark:text-slate-400" data-id="element-641">
            {hint}
          </p>}
        {error && <p className="mt-1 text-xs text-red-600 dark:text-red-400" data-id="element-642">{error}</p>}
      </div>;
});
Select.displayName = 'Select';